import { html } from 'lit';

import '../../../components/misc/neb-icon';
import { CSS_COLOR_ERROR } from '../../../../packages/neb-styles/neb-variables';

import { getScannerVersionsByPlatform } from './version-processor';

const SCANNER_HELP_URL =
  'https://chirotouch.my.site.com/cloud/s/article/Scanning-Documents-Directly-into-ChiroTouch';

const SUPPORT_TICKET_URL =
  'https://chirotouch.my.site.com/cloud/s/createrecord/CTX_Create_Case';

export const getUpdateMessage = ({ version, platform }) => {
  const versions = getScannerVersionsByPlatform(platform);
  const v1 = versions[0].version;
  const v2 = versions[1].version;
  const v1Url = versions[0].url;
  const v2Url = versions[1].url;

  const BASE_MESSAGE =
    "If you're experiencing issues such as cropped images or failed scans, we recommend updating to";

  if (version === v1) {
    return html`${BASE_MESSAGE}
      <a href="${v2Url}"><u>latest version ${v2}</u></a>`;
  }

  if (version === v2) {
    return html`${BASE_MESSAGE}
      <a href="${v1Url}"><u>previous version ${v1}</u></a>`;
  }
  return '';
};

export const parseScannerConfiguration = scannerConfig => {
  const errors = [];

  if (scannerConfig.scannersCount === 0) {
    errors.push('No scanners found');
  }

  if (scannerConfig.documentSourcesCount === 0) {
    errors.push('No document sources found');
  }

  if (scannerConfig.resolutionsCount === 0) {
    errors.push('No resolutions found');
  }

  if (scannerConfig.colorsCount === 0) {
    errors.push('No colors found');
  }

  if (scannerConfig.pageSizesCount === 0) {
    errors.push('No page sizes found');
  }

  return errors;
};

export const getWarningMessage = scannerConfig => {
  const errors = parseScannerConfiguration(scannerConfig);

  if (errors.length === 0) {
    return html``;
  }
  return html`
    <div style="display: flex; align-items: center; gap: 8px;">
      <neb-icon
        icon="neb:warning"
        style="width: 24px; height: 24px; fill: ${CSS_COLOR_ERROR};"
      ></neb-icon>
      <span>The scanner service may not be configured correctly:</span>
    </div>
    <ul>
      ${errors.map(error => html`<li>${error}</li>`)}
    </ul>
  `;
};

export const getScannerHelpMessage = ({ version, platform, scannerConfig }) => {
  const updateMessage = getUpdateMessage({ version, platform });

  return html`
    <p>
      You are currently using: <br />
      <b>KnowledgeOne Scan Service (${platform}) Version ${version}</b>
    </p>
    <p>${getWarningMessage(scannerConfig)}</p>
    <p>${updateMessage}</p>

    For detailed, step-by-step guidance:
    <ul>
      <li>
        Visit our
        <a target="_blank" href="${SCANNER_HELP_URL}"
          ><u>ChiroTouch Community article</u></a
        >
      </li>
      <li>
        <a target="_blank" href="${SUPPORT_TICKET_URL}"
          ><u>Open a support ticket</u></a
        >
        if you need further assistance
      </li>
    </ul>
  `;
};
